export default "__VITE_ASSET__mWd1Rui0__"